import { mode } from '@chakra-ui/theme-tools';

var baseStyle = props => ({
  fontSize: 'xs',
  color: mode('gray.900', 'white')(props),
  marginEnd: 0,
  marginBottom: 0,
  fontWeight: 'normal',
  transition: 'all 0.2s',
  opacity: 1,
  _disabled: {
    opacity: 0.4
  },
  _invalid: {
    color: mode('red.500', 'red.300')(props)
  }
});

export default {
  baseStyle
};
//# sourceMappingURL=FormLabel.js.map